import { render } from "./DocumentElement.vue?vue&type=template&id=7caf8464&scoped=true"
import script from "./DocumentElement.vue?vue&type=script&lang=js"
export * from "./DocumentElement.vue?vue&type=script&lang=js"

import "./DocumentElement.vue?vue&type=style&index=0&id=7caf8464&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caf8464"]])

export default __exports__